import {toFarsiNumber} from "../../cudtom-hooks/en-to-persian";

const ReportsBoxColumn = ({firstRowReport, waterType, data}) => {
    let defaultCount = toFarsiNumber(0)
    return(
        <div className='column w-full sm:w-1/2 [&:not(:last-child)]:border-b lg:!border-b-0 lg:w-1/3 grow py-2 px-2 [&:not(:last-child)]:border-r'>
            <div dir='rtl' className='flex justify-between mb-2'>
                <span>{firstRowReport}</span>
                <span>{data ? data[0] : defaultCount}</span>
            </div>
            <div dir='rtl' className='flex justify-between mb-2'>
                <span>درخواست های {waterType} تحویل شده:</span>
                <span>{data ? data[1] : defaultCount}</span>
            </div>
            <div dir='rtl' className='flex justify-between mb-2'>
                <span>حجم {waterType} درخواست شده:</span>
                <span><span>{data ? data[2] : defaultCount} </span><span>لیتر</span></span>
            </div>
            <div dir='rtl' className='flex justify-between mb-2'>
                <span>حجم {waterType} تحویل شده:</span>
                <span><span>{data ? data[3] : defaultCount} </span><span>لیتر</span></span>
            </div>
            <div dir='rtl' className='flex justify-between mb-2'>
                <span>درخواست {waterType} رد شده:</span>
                <span><span>{data ? data[4] : defaultCount} </span><span>درخواست</span></span>
            </div>
        </div>
    )
}

export default ReportsBoxColumn